import { Star } from "@material-ui/icons";
import { FeaturedList } from "./list";

export const FeaturedIcon = Star;

export { FeaturedList };
